<section class="notes-panel">
  <div class="notes-header">
    <div class="title-block">
      <button
        *ngIf="showBack"
        type="button"
        class="btn btn-link back-btn"
        (click)="onBackClick()">
        <i class="bi bi-arrow-left"></i>
        Back
      </button>
      <h3>{{ isEditing ? 'Edit entry' : 'New entry' }}</h3>
      <p class="subtitle">
        Dictate, record a voice note, or type — then save to your journal.
      </p>
    </div>
  </div>

  <div class="transcribing-banner" *ngIf="isEntryTranscribing">
    <div class="spinner" aria-hidden="true"></div>
    <span>This voice note is still being transcribed. You can edit it once transcription finishes.</span>
  </div>

  <div class="notes-actions" *ngIf="!isEntryTranscribing">
    <div class="model-note" *ngIf="!isDictationSessionActive">
      <small class="hint">
        In-browser dictation uses the lightweight Vosk small model. For higher accuracy, use
        <strong>Record voice note</strong> (server transcription).
      </small>
    </div>

    <div class="action-row">
      <div class="group">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="startDictation()"
          *ngIf="!isDictating"
          [disabled]="recorderState === 'recording' || recorderState === 'transcribing' || isDictationSessionActive">
          <i class="bi bi-mic"></i>
          {{ isDictationLoading ? 'Loading dictation…' : 'Dictate' }}
        </button>

        <button
          type="button"
          class="btn btn-primary"
          (click)="stopDictation()"
          *ngIf="isDictating"
          [disabled]="isFinalizingDictation">
          <i class="bi bi-stop-circle"></i>
          {{ isFinalizingDictation ? 'Finalizing…' : 'Stop & add to notes' }}
        </button>
      </div>

      <div class="group">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="startVoiceNote()"
          [disabled]="recorderState === 'recording' || recorderState === 'transcribing' || isDictationSessionActive">
          <i class="bi bi-volume-up"></i>
          Record voice note
        </button>

        <button
          type="button"
          class="btn btn-primary"
          (click)="stopRecordingAndEnqueue()"
          *ngIf="recorderState === 'recording' && recorderKind === 'voice'">
          <i class="bi bi-stop-circle"></i>
          Stop & Transcribe
        </button>
      </div>
    </div>
  </div>

  <div class="dictation-state" *ngIf="isDictationLoading && !isDictating">
    <div class="spinner" aria-hidden="true"></div>
    <div class="dictation-copy">
      <span>Loading {{ clientDictation.selectedModel.label | lowercase }} speech model…</span>
    </div>
  </div>

  <div class="capture-wrap" *ngIf="(isDictating || isFinalizingDictation) && !isEntryTranscribing">
    <label for="dictationCapture">Live capture</label>
    <textarea
      id="dictationCapture"
      class="capture-textarea"
      rows="5"
      readonly
      [value]="dictationLiveText"
      placeholder="Your speech will appear here as you talk…"></textarea>
    <small class="hint">
      {{ isFinalizingDictation ? 'Finalizing the last words…' : 'Speak naturally. Everything is captured here first and added to your notes when you stop.' }}
    </small>
  </div>

  <div class="transcribe-state" *ngIf="recorderState === 'transcribing'">
    <div class="spinner" aria-hidden="true"></div>
    <span>Uploading voice note…</span>
  </div>

  <div class="error-state" *ngIf="recorderState === 'error' && errorMessage">
    <i class="bi bi-exclamation-triangle"></i>
    <span>{{ errorMessage }}</span>
  </div>

  <div class="textarea-wrap" [class.dimmed]="isDictationSessionActive">
    <label for="noteTitle">Title</label>
    <input
      id="noteTitle"
      class="note-title-input"
      type="text"
      [(ngModel)]="noteTitle"
      placeholder="Journal entry"
      [disabled]="isEditorLocked || isSavingNote" />

    <label for="notesText">Your notes</label>
    <textarea
      id="notesText"
      class="notes-textarea"
      rows="6"
      [(ngModel)]="notesText"
      (ngModelChange)="savedJournalId = null"
      placeholder="Dictated or typed notes appear here…"
      [disabled]="isEditorLocked"></textarea>

    <div class="save-row" *ngIf="!isEntryTranscribing">
      <button
        type="button"
        class="btn btn-primary"
        (click)="saveNoteToJournal()"
        [disabled]="!canSaveNote">
        <i class="bi bi-save"></i>
        {{ saveButtonLabel }}
      </button>
      <small class="saved-hint" *ngIf="savedJournalId && !isEditing">
        Saved to your journal.
      </small>
    </div>

    <small class="hint" *ngIf="!isEditorLocked && !savedJournalId">
      Edit your note, then tap {{ isEditing ? 'Update entry' : 'Save to journal' }} to keep it.
    </small>
    <small class="hint" *ngIf="isDictating">
      Notes are updated when you tap “Stop & add to notes”.
    </small>
  </div>
</section>
